// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1AsOz","title":"Header_title__3eqDg","left":"Header_left__3iO-m","clinicName":"Header_clinicName__3WSk_"};